import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faGoogle, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons'


var footer_icon = {
    textAlign: "center",
    paddingRight: "10px",
    paddingLeft: "10px",
    paddingTop: "5px",
}

function Footer() {
    return (
        <footer>
            <center>
            <a href="https://github.com/Ruby-Adam-softwares"><FontAwesomeIcon className="footer-fa-icon" icon={faGithub} color={"white"} style={footer_icon}/></a>
            <a href="https://www.instagram.com/rudovruben"><FontAwesomeIcon className="footer-fa-icon" icon={faInstagram} color={"white"} style={footer_icon}/></a>
            <a href="https://www.linkedin.com/in/ruben-rudov-106a22204/"><FontAwesomeIcon className="footer-fa-icon" icon={faLinkedin} color={"white"} style={footer_icon}/></a>
            <a href="mailto:adamruben.softwares@gmail.com"><FontAwesomeIcon className="footer-fa-icon" icon={faGoogle} color={"white"} style={footer_icon}/></a>
            <p>© Ruben & Adam softwares 2021</p>
            </center>
      </footer>
    )
}

export default Footer